<template>
  <div class="quoting--autocomplete--wrapper" v-closable="{ exclude: ['QuotingAutoComplete'], isClosable: true, handler: 'handleCancel'}">
    <div class="quoting--autocomplete--container" :ref="'QuotingAutoComplete'">
      <span class="top--placeholder" :class="{'visibility': focus || selectedValue !== null}">
        {{ inputLabel != null ? inputLabel : inputPlaceholder  }}
      </span>
      <v-autocomplete
        v-model="inputModel"
        :items="list"
        @update:search-input="handleSearch"
        color="#767676"
        hide-no-data
        :item-text="translate != null ? (item) => ($t(`${translate}.${item[value]}`)) : value"
        :item-value="value"
        :placeholder="inputPlaceholder"
        @change="selectItem"
        :disabled="inputDisabled"
        outlined
        return-object
      >
        <template
          v-if="hasSelectSlot"
          v-slot:selection="data"
        >
          <slot name="itemSelectSlot" :selected="data.selected"></slot>
        </template>
        <template
          v-if="hasItemSlot"
          v-slot:item="data"
        >
          <slot name="itemListSlot" :item="data.item"></slot>
        </template>

      </v-autocomplete>
    </div>
    <!-- <div v-show="focus" class="quoting--autocomplete--list">
      <ul>
        <template v-for="(item, index) in searchingList">
          <li @click="selectItem($event, item)" :key="index">
            <slot name="itemListSlot" :item="item"></slot>
            <span v-if="!hasItemSlot">{{item}}</span>
          </li>
        </template>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
export default {
  name: 'QuotingAutoComplete',
  props: {
    inputPlaceholder: { type: String, default: null },
    list: { value: Object | Array, default: () => [] },
    value: { value: Array | String, default: '' },
    inputLabel: { type: String, default: null },
    inputDisabled: { type: Boolean, default: false },
    translate: {type: String, default: null}
  },
  data () {
    return {
      focus: false,
      inputModel: '',
      localList: [],
      searchingList: [],
      selectedValue: null,
      editableContentRef: uuid.v1(),
      isEditing: false,
      search: null,
      translatedTypes: ['Road', 'Air', 'Ocean']
    }
  },
  mounted () {
    this.handleInit()
  },
  methods: {
    handleInit () {
      this.localList = [...this.list]
      this.searchingList = [...this.list]
    },
    handleInput (evt) {
      this.inputModel = evt.target.innerText
    },
    handleSearch (value) {
      if (value != null) {
        this.$emit('search', value)
      }
    },
    handleCancel () {
      setTimeout(() => {
        this.focus = false
      }, 20)
    },
    selectItem (item) {
      this.isEditing = false
      this.$emit('selectedEvent', item)
    },
    handleClick () {
      if (this.selectedValue !== null) {
        this.isEditing = true
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs[this.editableContentRef].focus()
            this.focus = true
          }, 20)
        })
      }
    },
    handleBlurInput (evt) {
      this.isEditing = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.focus = false
        }, 200)
      })
    }
  },
  computed: {
    hasItemSlot: function () {
      return !!this.$scopedSlots.itemListSlot
    },
    hasSelectSlot: function () {
      return !!this.$scopedSlots.selectedSlot
    }
  },
  watch: {
    inputModel: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val.length > 0) {
          if (this.localList.length > 0) {
            if (typeof this.localList[0] === 'string') {
              this.searchingList = [...this.localList.filter((searchable) => {
                return searchable.toLowerCase().includes(val.toLowerCase())
              })]
            } else {
              this.searchingList = [...this.localList.filter((searchableObject) => {
                let flag = false
                Object.keys(searchableObject).forEach((key) => {
                  if (searchableObject[key] === 'string') {
                    flag = searchableObject[key].toLowerCase().includes(val.toLowerCase())
                  }
                })
                return flag
              })]
            }
          }
        } else {
          this.searchingList = [...this.localList]
        }
      }
    }
  },
  beforeDestroy() {
    this.inputModel = ''
    this.selectedValue = null
  },
}
</script>

<style lang="scss" scoped>
  .quoting--autocomplete--wrapper {
    position: relative;
    .quoting--autocomplete--container {
      z-index: 1;
      .top--placeholder {
        font-size: 10px;
        font-weight: 500;
        visibility: hidden;
        &.visibility {
          transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
          -webkit-transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
          -ms-transition: 300ms cubic-bezier(0.4, 0, 0.2, 1);
          visibility: visible;
        }
      }
      .editable--input {
        width: 100%;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: 1px solid #c5c5c5;
        border-radius: 4px;
        background-color: transparent;
        font-family: inherit;
        color: #767676;
        min-height: 25px;
        font-size: 18px;
        padding-left: 10px;
        &.focus {
          border-color: #484848;
        }
        &.disabled {
          border-color: #e2e2e2;
          input {
            &::placeholder {
              color: #e2e2e2;
            }
          }
        }
        input {
          width: 100%;
          height: 100%;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
          border-radius: 0;
          -moz-border-radius: 0;
          -webkit-border-radius: 0;
          outline: none;
          border: none;
          background-color: transparent;
          font-family: inherit;
          color: #767676;
          &::placeholder {
          color: #c5c5c5;
          }
        }
      }
    }
    .quoting--autocomplete--list {
      position: absolute;
      width: 100%;
      top: 52px;
      left: 0;
      z-index: 9;
      ul {
        max-height: 75px;
        overflow-y: auto;
        background-color: white;
        border-radius: 5px;
        border: 1px solid #e3e3e3;
        padding: 0 0;
        background-color: #ffffff;
        li {
          width: 100%;
          min-height: 25px;
          padding-left: 5px;
          color: #767676;
          &:hover {
            background-color: #e3e3e3;
          }
        }
      }
    }
  }
</style>
